<template>
  <div class="row">
    <div class="col">
      <div class="wrapper">
        <UiTabs tag="div" :tabs="tabs" @tab-click="handleTabClick" />
      </div>
    </div>
  </div>
</template>

<script>
import UiTabs from '@/components/tabs/UiTabs.vue'
import syncQuery from '@/mixins/syncUrlQuery'

export default {
  components: { UiTabs },
  mixins: [syncQuery],
  data() {
    return {
      /**
       * Log level
       * @values null, '0', '1', '2',
       *   */
      level: null,
    }
  },
  computed: {
    /** Array of Tabs */
    tabs() {
      return [
        {
          key: 'all',
          label: 'All',
          isActive: !this.level,
          attrs: {
            to: {
              query: { level: null, page: null },
            },
          },
        },
        {
          key: 'error',
          label: 'Errors',
          isActive: this.level === '1',
          attrs: {
            to: {
              query: { level: '1', page: 1 },
            },
          },
        },
        {
          key: 'warnings',
          label: 'Warnings',
          isActive: this.level === '2',
          attrs: {
            to: {
              query: { level: '2', page: 1 },
            },
          },
        },
        {
          key: 'user',
          label: 'User',
          isActive: this.level === '8',
          attrs: {
            to: {
              query: { level: '8', page: 1 },
            },
          },
        },
        {
          key: 'throttle',
          label: 'Throttle',
          isActive: this.level === '16',
          attrs: {
            to: {
              query: { level: '16', page: 1 },
            },
          },
        },
        {
          key: 'info',
          label: 'Info',
          isActive: this.level === '0',
          attrs: {
            to: {
              query: { level: '0', page: 1 },
            },
          },
        },
      ]
    },
  },
  mounted() {
    /** Sync local field `level` with url query parameter `level` */
    this.syncQuery({ localField: 'level', queryField: 'level' })
  },
  methods: {
    /**
     * Update url query parameters after click Tab.
     *
     * @param {object} event Tab object.
     * @public
     **/
    handleTabClick(event) {
      const query = {
        ...this.$query,
        ...event.attrs.to.query,
      }

      this.updateQueryParams({ query })
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  border-bottom: 1px solid $color-gray-50;
}
</style>
